import { Hamburger } from './Hamburger';

export type { TypeHamburgerProps } from './types';
export default Hamburger;
